import request from '@/utils/request';

// 选课首页商品分组列表
export function getProductList(params) {
  return request({
    url: '/course/front/home/product',
    method: 'get',
    params
  });
}

// 选课首页商品类别列表
export function getProductType() {
  return request({
    url: '/course/front/product/category',
    method: 'get'
  });
}

// 选课搜索
export function getProductSearch(params) {
  return request({
    url: '/course/front/product/list',
    method: 'get',
    params
  });
}

// 查询选课单列表
export function getCartList(params) {
  return request({
    url: '/course/front/cart/list',
    method: 'get',
    params
  });
}

// 选中商品金额计算有优惠计算顺序之后的接口
export function cartAmount(params) {
  return request({
    url: `/course/front/cart/getCartAmountBySort/${params}`,
    method: 'get'
  });
}

// 选中商品金额计算
// export function cartAmount(params) {
//   return request({
//     url: `/course/front/cart/amount/${params}`,
//     method: 'get'
//   });
// }

// 删除选课单
export function delCartList(params) {
  return request({
    url: `/course/front/cart/${params}`,
    method: 'delete'
  });
}
// 商品详情
export function getProductDetails(id) {
  return request({
    url: `/course/front/product/detail/${id}`,
    method: 'get'
  });
}

// sku详情
export function getSkuDetails(productId) {
  return request({
    url: `/course/front/product/sku/${productId}`,
    method: 'get'
  });
}

export function getFrontProductDetail(id) {
  return request({
    url: '/course/front/product/detail/' + id,
    method: 'get'
  });
}

// 轮播图
export function getBanner(params) {
  return request({
    url: '/system/front/banner/list',
    method: 'get',
    params
  });
}

// 获取购物车数量
export function getCartCount() {
  return request({
    url: '/course/front/cart/count',
    method: 'get'
  });
}

// 加入(新增)选课单
export function addCart(data) {
  return request({
    url: '/course/front/cart',
    method: 'post',
    data
  });
}
// 更新选课单
export function updateCart(data) {
  return request({
    url: '/course/front/cart',
    method: 'put',
    data
  });
}

// 查询商品赠课列表
export function getProductGive(id) {
  return request({
    url: `/course/front/product/give/${id}`,
    method: 'get'
  });
}

// 获取续报课程
export function getXubaoProduct(params) {
  return request({
    url: '/activity/front/product/activity/follow/' + params.followId,
    method: 'get',
    params
  });
}

// 获取金刚区列表
export function getKingkongList() {
  return request({
    url: '/system/front/king/kong/list',
    method: 'get'
  });
}

// 获取商品组商品列表
export function getProductGroupList(id) {
  return request({
    url: '/system/front/operate/product/group/getProductsById/' + id + '?type=H5',
    method: 'get'
  });
}
// 获取商品组信息
export function getProductGroupInfo(id) {
  return request({
    url: '/system/front/operate/product/group/getProductsById/group/' + id + '?type=H5',
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/course/index.js